export enum ContactType {
  None = 99,
  Standard = 0,
  User = 1,
  Solicitor = 2,
  LocalAuthority = 3,
  Publication = 4,
  MortgageProvider = 5,
  EstateAgent = 6,
  Applicant = 7,
  Landlord = 8,
  Vendor = 9,
  Contractor = 10,
  UtilitySupplier = 11,
  Bank = 12,
  ManagingAgent = 13,
  Guarantor = 14,
  Referee = 15,
  Company = 16,
  BlockManagementCompany = 17,
  InsuranceCompany = 18,
  AuctionHouse = 19,
  FinancialAdvisor = 20,
  BoardSupplier = 21,
  GeneralBusinssContact = 22,
}

export enum PreferredDeliveryMethod {
  Email = 0,
  Print = 1,
  EmailPrint = 2,
  NotRequired = 99,
}
